import { useTheme } from '@mui/system';

interface CompareRemoveIconProps {
  size?: number;
  fill?: string;
}

export const CompareRemoveIcon = ({
  size = 18,
  fill: fillProp,
}: CompareRemoveIconProps) => {
  const theme = useTheme();

  const fill = fillProp || theme.palette.primary.main;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_381_54755)">
        <path
          d="M14.0003 10.668C12.157 10.668 10.667 12.158 10.667 14.0013C10.667 15.8446 12.157 17.3346 14.0003 17.3346C15.8437 17.3346 17.3337 15.8446 17.3337 14.0013C17.3337 12.158 15.8437 10.668 14.0003 10.668ZM15.667 15.198L15.197 15.668L14.0003 14.4713L12.8037 15.668L12.3337 15.198L13.5303 14.0013L12.3337 12.8046L12.8037 12.3346L14.0003 13.5313L15.197 12.3346L15.667 12.8046L14.4703 14.0013L15.667 15.198Z"
          fill={fill}
        />
      </g>
      <path
        d="M6.7575 10.4999H2.25C1.8375 10.4999 1.5 10.8374 1.5 11.2499C1.5 11.6624 1.8375 11.9999 2.25 11.9999H6.7575V13.3424C6.7575 13.6799 7.1625 13.8449 7.395 13.6049L9.48 11.5124C9.6225 11.3624 9.6225 11.1299 9.48 10.9799L7.395 8.8874C7.1625 8.6474 6.7575 8.8199 6.7575 9.1499V10.4999ZM11.2425 8.8424V7.4999H15.75C16.1625 7.4999 16.5 7.1624 16.5 6.7499C16.5 6.3374 16.1625 5.9999 15.75 5.9999H11.2425V4.6574C11.2425 4.3199 10.8375 4.1549 10.605 4.3949L8.52 6.4874C8.3775 6.6374 8.3775 6.8699 8.52 7.0199L10.605 9.1124C10.8375 9.3449 11.2425 9.1799 11.2425 8.8424Z"
        fill={fill}
      />
    </svg>
  );
};
